import { useRef, useState } from "react"
import Header from "../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, TextField, Button, Stack } from "@mui/material"
import fetchwrapper from "../../services/interceptors/fetchwrapper"
import BackIcon from "../../components/BackIcon"
import normalFormatDate from "../utils/date/DDMMYYYFormatDate"
import CustomFieldsetAccordion from "../../components/CustomFieldsetAccordion"
import { useQuery } from "@tanstack/react-query"
import CustomBackdrop from "../../components/CustomBackdrop"
import CustomAutocomplete from "../../components/CustomAutocomplete"
import CustomDatePicker from "../../components/CustomDatePicker"
import dayjs from "dayjs"
import CustomFieldset from "../../components/CustomFieldset"
import CustomAggregationSegregationComponent from "../../components/CustomAggregationSegregationComponent.js"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})

const ContainerFiltrosGenerales = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto auto",
  gridTemplateAreas: `
          "IVendedor IVendedor IVendedor IVendedor IVendedor IVendedor IVendedor IVendedor IVendedor IVendedor IVendedor IVendedor"
          "ILocalidad ILocalidad ILocalidad ILocalidad ILocalidad ILocalidad ILocalidad ILocalidad ILocalidad ILocalidad ILocalidad ILocalidad"
          "IRangoEmision IRangoEmision IRangoEmision IRangoEmision IRangoEmision IRangoEmision IRangoEmision IRangoEmision IRangoEmision IRangoEmision IRangoEmision IRangoEmision"
          "IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar"
        `,
  gap: "8px",
  rowGap: "12px",
  alignItems: "center",
}))

const IVendedor = styled(Box)({
  gridArea: "IVendedor",
})
const ILocalidad = styled(Box)({
  gridArea: "ILocalidad",
})

const IRangoEmision = styled(Box)({
  gridArea: "IRangoEmision",
})
const IBtnFiltrar = styled(Box)({
  gridArea: "IBtnFiltrar",
})

const ContainerRangoFechaInner = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto auto",
  gridTemplateAreas: `
            "IFechaInicial IFechaInicial IFechaInicial IFechaInicial IFechaInicial IFechaInicial IFechaFinal IFechaFinal IFechaFinal IFechaFinal IFechaFinal IFechaFinal"
          `,
  gap: "8px",
  alignItems: "center",
  // Versión para pantallas pequeñas
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto auto",
    gridTemplateAreas: `
      "IFechaInicial"
      "IFechaFinal"
    `,
    gap: "12px",
  },
}))

const RangoFechaIFechaInicial = styled(Box)({
  gridArea: "IFechaInicial",
})
const RangoFechaIFechaFinal = styled(Box)({
  gridArea: "IFechaFinal",
})

// const Propinas = () => {
//   const [refreshCustomReadableTableServerKey, setRefreshCustomReadableTableServerKey] = useState(0) // <-- Controla el reinicio del custom readable table server
//   const [expanded, setExpanded] = useState(true)
//   const handleToggle = () => {
//     setExpanded(!expanded)
//   }
//   const [filtrosGenerales, setFiltrosGenerales] = useState({
//     localidadCB: null,
//     loccodigo: "",
//     locdescri: "",
//     vendedorCB: null,
//     vencodigo: "",
//     vennombre: "",
//     // fechaInicioEmision: dayjs(new Date()),
//     // fechaFinEmision: dayjs(new Date()),
//   })
//   const handleSetFiltrosGenerales = (k, v) => setFiltrosGenerales((prev) => ({ ...prev, [k]: v }))

//   const {
//     data: dataSupervisorInfo = [],
//     isError: dataErrorSupervisorInfo,
//     isFetching: isFetchingSupervisorInfo,
//     isLoading: isLoadingSupervisorInfo,
//     refetch: refetchGetAllSupervisorInfo,
//   } = useGetSupervisorInfo()
//   function useGetSupervisorInfo() {
//     return useQuery({
//       queryKey: ["ComisionSupervisorInfo"],
//       queryFn: async () => {
//         const response = await fetchwrapper(`/comisiones/getUsuarioEsSupervisor`)
//         let result = await response.json()
//         result = result.data

//         // Inicializo el key de refresh de mi readbale table server en 1, ya que en 0 no se mostrara
//         // y seteo en null las fechas de emision para que no filtre por eso
//         if (!result?.esSupervisor) {
//           setRefreshCustomReadableTableServerKey(1)
//           setFiltrosGenerales((prev) => ({
//             ...prev,
//             fechaInicioEmision: null,
//             fechaFinEmision: null,
//           }))
//         }

//         return result
//       },
//       onError: () => {
//         console.log("Error fetching data info supervisor")
//       },
//     })
//   }

//   const {
//     data: dataAllVendedores = [],
//     isError: dataErrorAllVendedores,
//     isFetching: isFetchingAllVendedores,
//     isLoading: isLoadingAllVendedores,
//     refetch: refetchGetAllAllVendedores,
//   } = useGetAllVendedores()

//   function useGetAllVendedores() {
//     return useQuery({
//       queryKey: ["ComisionesVendedores"],
//       queryFn: async () => {
//         const response = await fetchwrapper(`/comisiones/getVendedores`)
//         let result = await response.json()
//         result = result.data
//         return result
//       },
//       onError: () => {
//         console.log("Error fetching data vendedores")
//       },
//     })
//   }

//   const {
//     data: dataAllLocalidades = [],
//     isError: dataErrorAllLocalidades,
//     isFetching: isFetchingAllLocalidades,
//     isLoading: isLoadingAllLocalidades,
//     refetch: refetchGetAllAllLocalidades,
//   } = useGetAllLocalidades()
//   function useGetAllLocalidades() {
//     return useQuery({
//       queryKey: ["ComisionesLocalidades"],
//       queryFn: async () => {
//         const response = await fetchwrapper(`/comisiones/getLocalidades`)
//         let result = await response.json()
//         result = result.data
//         return result
//       },
//       onError: () => {
//         console.log("Error fetching data localidades")
//       },
//     })
//   }

//   return (
//     <ThemeProvider theme={theme}>
//       <Header />
//       <div className="main main-app p-3 p-lg-4">
//         <BackIcon />
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             margin: "0 30px 30px 30px",
//             fontSize: "25px",
//           }}
//         >
//           <b>Propinas</b>
//         </div>
//         <CustomBackdrop
//           isLoading={
//             isLoadingAllVendedores ||
//             isFetchingAllVendedores ||
//             isLoadingAllLocalidades ||
//             isFetchingAllLocalidades ||
//             isLoadingSupervisorInfo ||
//             isFetchingSupervisorInfo
//           }
//         />
//         <Box className={StyledRoot}>
//           {dataSupervisorInfo.esSupervisor && (
//             <CustomFieldsetAccordion title="Filtros Generales" expanded={expanded} onToggle={handleToggle}>
//               <ContainerFiltrosGenerales>
//                 <IVendedor>
//                   <CustomAutocomplete
//                     label="Vendedor"
//                     selectedOption={filtrosGenerales.vendedorCB}
//                     setSelectedOption={(v) => {
//                       setFiltrosGenerales((prev) => ({
//                         ...prev,
//                         vendedorCB: v,
//                         vencodigo: v?.vencodigo ?? "",
//                         vennombre: v?.vennombre ?? "",
//                       }))
//                     }}
//                     options={dataAllVendedores}
//                   />
//                 </IVendedor>
//                 <ILocalidad>
//                   <CustomAutocomplete
//                     label="Localidad"
//                     selectedOption={filtrosGenerales.localidadCB}
//                     setSelectedOption={(v) => {
//                       setFiltrosGenerales((prev) => ({
//                         ...prev,
//                         localidadCB: v,
//                         loccodigo: v?.loccodigo ?? "",
//                         locdescri: v?.locdescri ?? "",
//                       }))
//                     }}
//                     options={dataAllLocalidades}
//                   />
//                 </ILocalidad>

//                 {/* <IRangoEmision>
//                   <CustomFieldset title={"Rango de fechas Emisión"} sx={{ marginTop: "15px" }}>
//                     <ContainerRangoFechaInner>
//                       <RangoFechaIFechaInicial>
//                         <CustomDatePicker
//                           label="Fecha Inicial Emisión"
//                           value={filtrosGenerales.fechaInicioEmision}
//                           defaultValue={dayjs(new Date())}
//                           setValue={(v) => handleSetFiltrosGenerales("fechaInicioEmision", v)}
//                           isOptional={true}
//                           // slotProps={{ textField: { fullWidth: true } }}
//                         />
//                       </RangoFechaIFechaInicial>
//                       <RangoFechaIFechaFinal>
//                         <CustomDatePicker
//                           label="Fecha Final Emisión"
//                           value={filtrosGenerales.fechaFinEmision}
//                           defaultValue={dayjs(new Date())}
//                           setValue={(v) => handleSetFiltrosGenerales("fechaFinEmision", v)}
//                           isOptional={true}
//                           // slotProps={{ textField: { fullWidth: true } }}
//                         />
//                       </RangoFechaIFechaFinal>
//                     </ContainerRangoFechaInner>
//                   </CustomFieldset>
//                 </IRangoEmision> */}

//                 <IBtnFiltrar>
//                   <Button
//                     variant="contained"
//                     onClick={() => {
//                       // Refrescar el CustomReadableTableServer con los nuevos filtros de 'filtrosGenerales'
//                       setRefreshCustomReadableTableServerKey((prev) => prev + 1)
//                     }}
//                   >
//                     Filtrar
//                   </Button>
//                 </IBtnFiltrar>
//               </ContainerFiltrosGenerales>
//             </CustomFieldsetAccordion>
//           )}

//           {refreshCustomReadableTableServerKey !== 0 && (
//             <CustomReadableTableServer
//               key={refreshCustomReadableTableServerKey} // Fuerza re-montaje al cambiar
//               endpoint="/propinas/getPropinas"
//               endpointJson={{
//                 externalFilters: {
//                   // rangoFechaEmision: [filtrosGenerales.fechaInicioEmision, filtrosGenerales.fechaFinEmision],
//                   loccodigo: filtrosGenerales.loccodigo,
//                   vencodigo: filtrosGenerales.vencodigo,
//                 },
//               }}
//               errorMsgFilterSearch="Error en cargar datos"
//               queryKeyModal="PropinasGetPropinas"
//               perPage={10}
//               columnsTable={[
//                 {
//                   accessorKey: "loccodigo",
//                   header: "Código Localidad",
//                   size: 200,
//                   Cell: ({ cell }) => <span>{cell.getValue()}</span>,
//                 },
//                 {
//                   accessorKey: "locdescri",
//                   header: "Localidad",
//                   size: 150,
//                   Cell: ({ cell }) => <span>{cell.getValue()}</span>,
//                 },
//                 {
//                   accessorKey: "vencodigo",
//                   header: "Código Vendedor",
//                   size: 200,
//                   Cell: ({ cell }) => <span>{cell.getValue()}</span>,
//                 },
//                 {
//                   accessorKey: "vennombre",
//                   header: "Nombre Vendedor",
//                   size: 150,
//                   Cell: ({ cell }) => <span>{cell.getValue()}</span>,
//                 },
//                 {
//                   accessorKey: "valorcob",
//                   header: "Valor Cobrado",
//                   size: 200,
//                   Cell: ({ cell }) => <span>{cell.getValue()}</span>,
//                 },
//                 {
//                   accessorKey: "valorpropina",
//                   header: "Valor Propina",
//                   size: 200,
//                   Cell: ({ cell }) => <span>{cell.getValue()}</span>,
//                 },
//               ]}
//             />
//           )}
//         </Box>
//       </div>
//     </ThemeProvider>
//   )
// }

// export default Propinas

const Propinas = () => {
  const [refreshCustomReadableTableServerKey, setRefreshCustomReadableTableServerKey] = useState(0) // <-- Controla el reinicio del custom readable table server
  const [expanded, setExpanded] = useState(true)
  const handleToggle = () => {
    setExpanded(!expanded)
  }
  const [filtrosGenerales, setFiltrosGenerales] = useState({
    localidadCB: null,
    loccodigo: "",
    locdescri: "",
    vendedorCB: null,
    vencodigo: "",
    vennombre: "",
    fechaInicioEmision: dayjs(new Date()),
    fechaFinEmision: dayjs(new Date()),
  })
  const handleSetFiltrosGenerales = (k, v) => setFiltrosGenerales((prev) => ({ ...prev, [k]: v }))

  const {
    data: dataSupervisorInfo = [],
    isError: dataErrorSupervisorInfo,
    isFetching: isFetchingSupervisorInfo,
    isLoading: isLoadingSupervisorInfo,
    refetch: refetchGetAllSupervisorInfo,
  } = useGetSupervisorInfo()
  function useGetSupervisorInfo() {
    return useQuery({
      queryKey: ["ComisionSupervisorInfo"],
      queryFn: async () => {
        const response = await fetchwrapper(`/comisiones/getUsuarioEsSupervisor`)
        let result = await response.json()
        result = result.data

        // Inicializo el key de refresh de mi readbale table server en 1, ya que en 0 no se mostrara
        // y seteo en null las fechas de emision para que no filtre por eso
        if (!result?.esSupervisor) {
          setRefreshCustomReadableTableServerKey(1)
          setFiltrosGenerales((prev) => ({
            ...prev,
            fechaInicioEmision: null,
            fechaFinEmision: null,
          }))
        }

        return result
      },
      onError: () => {
        console.log("Error fetching data info supervisor")
      },
    })
  }

  const {
    data: dataAllVendedores = [],
    isError: dataErrorAllVendedores,
    isFetching: isFetchingAllVendedores,
    isLoading: isLoadingAllVendedores,
    refetch: refetchGetAllAllVendedores,
  } = useGetAllVendedores()

  function useGetAllVendedores() {
    return useQuery({
      queryKey: ["ComisionesVendedores"],
      queryFn: async () => {
        const response = await fetchwrapper(`/comisiones/getVendedores`)
        let result = await response.json()
        result = result.data
        return result
      },
      onError: () => {
        console.log("Error fetching data vendedores")
      },
    })
  }

  const {
    data: dataAllLocalidades = [],
    isError: dataErrorAllLocalidades,
    isFetching: isFetchingAllLocalidades,
    isLoading: isLoadingAllLocalidades,
    refetch: refetchGetAllAllLocalidades,
  } = useGetAllLocalidades()
  function useGetAllLocalidades() {
    return useQuery({
      queryKey: ["ComisionesLocalidades"],
      queryFn: async () => {
        const response = await fetchwrapper(`/comisiones/getLocalidades`)
        let result = await response.json()
        result = result.data
        return result
      },
      onError: () => {
        console.log("Error fetching data localidades")
      },
    })
  }

  const {
    data: dataAllPropinas = [],
    isError: dataErrorAllPropinas,
    isFetching: isFetchingAllPropinas,
    isLoading: isLoadingAllPropinas,
    refetch: refetchGetAllAllPropinas,
  } = useGetAllPropinas()

  function useGetAllPropinas(externalFilters = {}) {
    return useQuery({
      queryKey: ["PropinasValoresFinales"],
      queryFn: async () => {
        const options = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            externalFilters: {
              rangoFechaEmision: [filtrosGenerales.fechaInicioEmision, filtrosGenerales.fechaFinEmision],
              loccodigo: filtrosGenerales.loccodigo,
              vencodigo: filtrosGenerales.vencodigo,
            },
          }),
        }
        const response = await fetchwrapper(`/propinas/getAllPropinas`, options)
        let result = await response.json()
        result = result.data
        return result
      },
      onError: () => {
        console.log("Error fetching data propinas")
      },
      enabled: refreshCustomReadableTableServerKey > 0, // Si el refresh es mayor a 0 entonces va ejecutar esta peticion en el rederizado inicial (no es supervisor) y sino tendra que espererar a que de click en filtrar (es supervisor)
    })
  }

  const handleClickFiltrarBtn = async () => {
    await refetchGetAllAllPropinas()

    // Refrescar el CustomReadableTableServer con los nuevos filtros de 'filtrosGenerales'
    setRefreshCustomReadableTableServerKey((prev) => prev + 1)
  }

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Propinas</b>
        </div>
        <CustomBackdrop
          isLoading={
            isLoadingAllVendedores ||
            isFetchingAllVendedores ||
            isLoadingAllLocalidades ||
            isFetchingAllLocalidades ||
            isLoadingSupervisorInfo ||
            isFetchingSupervisorInfo ||
            isLoadingAllPropinas ||
            isFetchingAllPropinas
          }
        />
        <Box className={StyledRoot}>
          {dataSupervisorInfo.esSupervisor && (
            <CustomFieldsetAccordion title="Filtros Generales" expanded={expanded} onToggle={handleToggle}>
              <ContainerFiltrosGenerales>
                <IVendedor>
                  <CustomAutocomplete
                    label="Vendedor"
                    selectedOption={filtrosGenerales.vendedorCB}
                    setSelectedOption={(v) => {
                      setFiltrosGenerales((prev) => ({
                        ...prev,
                        vendedorCB: v,
                        vencodigo: v?.vencodigo ?? "",
                        vennombre: v?.vennombre ?? "",
                      }))
                    }}
                    options={dataAllVendedores}
                  />
                </IVendedor>
                <ILocalidad>
                  <CustomAutocomplete
                    label="Localidad"
                    selectedOption={filtrosGenerales.localidadCB}
                    setSelectedOption={(v) => {
                      setFiltrosGenerales((prev) => ({
                        ...prev,
                        localidadCB: v,
                        loccodigo: v?.loccodigo ?? "",
                        locdescri: v?.locdescri ?? "",
                      }))
                    }}
                    options={dataAllLocalidades}
                  />
                </ILocalidad>

                <IRangoEmision>
                  <CustomFieldset title={"Rango de fechas Emisión"} sx={{ marginTop: "15px" }}>
                    <ContainerRangoFechaInner>
                      <RangoFechaIFechaInicial>
                        <CustomDatePicker
                          label="Fecha Inicial Emisión"
                          value={filtrosGenerales.fechaInicioEmision}
                          defaultValue={dayjs(new Date())}
                          setValue={(v) => handleSetFiltrosGenerales("fechaInicioEmision", v)}
                          isOptional={true}
                          // slotProps={{ textField: { fullWidth: true } }}
                        />
                      </RangoFechaIFechaInicial>
                      <RangoFechaIFechaFinal>
                        <CustomDatePicker
                          label="Fecha Final Emisión"
                          value={filtrosGenerales.fechaFinEmision}
                          defaultValue={dayjs(new Date())}
                          setValue={(v) => handleSetFiltrosGenerales("fechaFinEmision", v)}
                          isOptional={true}
                          // slotProps={{ textField: { fullWidth: true } }}
                        />
                      </RangoFechaIFechaFinal>
                    </ContainerRangoFechaInner>
                  </CustomFieldset>
                </IRangoEmision>

                <IBtnFiltrar>
                  <Button variant="contained" onClick={handleClickFiltrarBtn}>
                    Filtrar
                  </Button>
                </IBtnFiltrar>
              </ContainerFiltrosGenerales>
            </CustomFieldsetAccordion>
          )}

          {refreshCustomReadableTableServerKey !== 0 && (
            <CustomAggregationSegregationComponent
              data={dataAllPropinas}
              columnsConfig={({ totalSumValorCobrado, totalSumValorPropina }) => [
                {
                  accessorKey: "locdescri",
                  header: "Descripción Localidad",
                  size: 200,
                  Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                },
                {
                  accessorKey: "vennombre",
                  header: "Nombre Vendedor",
                  size: 200,
                  Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                },
                {
                  accessorKey: "cxcfecemi",
                  header: "Fecha Emision Factura",
                  size: 250,
                  Cell: ({ cell }) => <span>{normalFormatDate(cell.getValue())}</span>,
                },
                {
                  accessorKey: "facnumfac",
                  header: "Factura",
                  size: 200,
                  Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                },
                {
                  accessorKey: "facsecuen",
                  header: "Secuencia Factura",
                  size: 250,
                  Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                },
                {
                  accessorKey: "cxcnumcomp",
                  header: "Numero De Comprobante",
                  size: 250,
                  Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                },
                {
                  accessorKey: "cxctippag",
                  header: "Tipo De Pago",
                  size: 200,
                  Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                },
                {
                  accessorKey: "valorcob",
                  header: "Valor Cobrado",
                  size: 200,
                  accessorFn: (row) => Number(row.valorcob) || 0, // El backend me esta devolviendo string de dos decimales, asi que necesito pasarlos de string a number
                  aggregationFn: "sum",
                  AggregatedCell: ({ cell, table }) => (
                    <>
                      Suma por {table.getColumn(cell.row.groupingColumnId ?? "").columnDef.header}:{" "}
                      <Box sx={{ color: "success.main", fontWeight: "bold" }}>
                        {cell.getValue()?.toLocaleString?.("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Box>
                    </>
                  ),
                  Cell: ({ cell }) => (
                    <span>
                      {cell.getValue()?.toLocaleString?.("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  ),
                  Footer: () => (
                    <Stack>
                      Total Valor Cobrado:
                      <Box color="warning.main">
                        {totalSumValorCobrado?.toLocaleString?.("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Box>
                    </Stack>
                  ),
                },
                {
                  accessorKey: "valorpropina",
                  header: "Valor Propina",
                  size: 200,
                  accessorFn: (row) => Number(row.valorpropina) || 0, // El backend me esta devolviendo string de dos decimales, asi que necesito pasarlos de string a number
                  aggregationFn: "sum",
                  AggregatedCell: ({ cell, table }) => (
                    <>
                      Suma por {table.getColumn(cell.row.groupingColumnId ?? "").columnDef.header}:{" "}
                      <Box sx={{ color: "success.main", fontWeight: "bold" }}>
                        {cell.getValue()?.toLocaleString?.("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Box>
                    </>
                  ),
                  Cell: ({ cell }) => (
                    <span>
                      {cell.getValue()?.toLocaleString?.("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  ),
                  Footer: () => (
                    <Stack>
                      Total Valor Propina:
                      <Box color="warning.main">
                        {totalSumValorPropina?.toLocaleString?.("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Box>
                    </Stack>
                  ),
                },
              ]}
              aggregations={{
                totalSumValorCobrado: (data) => data.reduce((acc, curr) => acc + Number(curr.valorcob), 0),
                totalSumValorPropina: (data) => data.reduce((acc, curr) => acc + Number(curr.valorpropina), 0),
              }}
              tableOptions={{
                initialState: {
                  grouping: [
                    // "state"
                  ],
                  sorting: [
                    // { id: "state", desc: false }
                  ],
                },
              }}
            />
          )}
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default Propinas
